import { styled, Box as BoxBase } from "@mui/material";

export const CurrencySelectFieldContainer = styled(BoxBase)(({ theme }) => ({
  position: "relative",
}));

export const LoadingIndicator = styled(BoxBase)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "56px", // Same height as MUI Select field
  width: "100%",
}));

